/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationUpdate } from '../../axios/organisationUpdate'
import type {
	OrganisationUpdateError,
	OrganisationUpdatePathParams,
	OrganisationUpdateRequest,
	OrganisationUpdateResponse,
} from '../../types/OrganisationUpdate'

export const organisationUpdateMutationKey = () => [{ url: '/organisations/:organisation' }] as const

export type OrganisationUpdateMutationKey = ReturnType<typeof organisationUpdateMutationKey>

export type OrganisationUpdateVariables = {
	organisation: OrganisationUpdatePathParams['organisation']
	data: OrganisationUpdateRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::update */
export function useOrganisationUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationUpdateResponse,
		AxiosError<OrganisationUpdateError>,
		OrganisationUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationUpdateMutationKey(),
		mutationFn: ({ organisation, data }: OrganisationUpdateVariables) =>
			organisationUpdate(organisation, data, config).then(res => res.data),
		...options,
	})
}
